module.exports = __webpack_public_path__ + "static/img/3.a8d020a7.jpg";